import Button from 'components/Button';
import _ from '@dh-fe/translate';
import React from 'react';
import OranumBgDesktop from './assets/section1_desktop_oranum.jpg';
import OranumBgDesktopCompress from './assets/section1_desktop_oranum.webp';
import OranumBgMobile from './assets/section1_mobile_oranum.jpg';
import OranumBgMobileCompress from './assets/section1_mobile_oranum.webp';

interface Content {
    title: string;
    subtitle: string;
    bgDesktop: string;
    bgMobile: string;
    bgDesktopCompress: string;
    bgMobileCompress: string;
    button: JSX.Element;
    note: string;
}

const OranumContent: Content = {
    title: _`Reach success with {site}!`.withData({ site: 'Oranum' }),
    subtitle: _`Get up to {share} income share. Benefit from all of our money-making features`.withData({
        share: '100%',
    }),
    bgDesktop: OranumBgDesktop,
    bgMobile: OranumBgMobile,
    bgDesktopCompress: OranumBgDesktopCompress,
    bgMobileCompress: OranumBgMobileCompress,
    button: <Button href="#featuresSection" type="primary">{_`Discover how!`}</Button>,
    note: _`Scroll down to find out why {site} is the #1 choice!`.withData({ site: 'Oranum' }),
};

// eslint-disable-next-line import/prefer-default-export
export const getContent = (): Content => {
    return OranumContent;
};
